const SIZES = {
  md: { img: "h-8 w-8 sm:h-12 sm:w-12", name: "text-sm sm:text-2xl", tag: "text-[10px]" },
  lg: { img: "h-10 w-10 sm:h-20 sm:w-20", name: "text-base sm:text-4xl", tag: "text-xs sm:text-sm" },
};

export function BrandLogo({ light = false, tagline = true, size = "md", className = "" }) {
  const s = SIZES[size];
  return (
    <span className={`flex items-center gap-1.5 sm:gap-3 shrink-0 ${className}`} data-testid="brand-logo">
      <img src="/logo-mark.png" alt="MoveTender logo" className={`${s.img} object-contain shrink-0`} />
      <span className="flex flex-col leading-none" style={{ fontFamily: "'Montserrat', sans-serif" }}>
        <span className={`font-black ${s.name} tracking-tight ${light ? "text-white" : "text-brandgrey"}`}>MOVETENDER</span>
        {tagline && <span className={`hidden sm:block ${s.tag} font-bold uppercase tracking-wide text-kinetic mt-1`}>Australia's Moving Marketplace</span>}
      </span>
    </span>
  );
}
